interface Props {
    name: string;
    label: string;
    value: number | null | undefined;
    onChange: (name: string, value: number) => void;
    required: boolean;
    min?: number | undefined;
    max?: number | undefined;
    hiddeLabel?: boolean;
}

export default function NumberField({
    name,
    label,
    value,
    required,
    onChange,
    min,
    max,
    hiddeLabel = false,
}: Props) {
    const onFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        event.target.classList.add('touched');
    };

    const formatCurrency = (value: number | null | undefined): string => {
        if (value === null || value === undefined) {
            return '';
        }
        return value.toLocaleString('es-ES');
    };

    return (
        <div className='mb-3'>
            {!hiddeLabel ? (
                <label htmlFor={name} key={`label-${name}`} className='form-label'>
                    {label}
                </label>
            ) : null}
            <input
                type='text'
                className='form-control'
                id={name}
                key={name}
                name={name}
                value={formatCurrency(value)}
                required={required}
                onChange={(e) => {
                    const inputText = e.target.value.replace(/[^0-9]/g, '');
                    onChange(name, parseInt(inputText) || 0);
                }}
                onFocus={onFocus}
                placeholder={label}
                min={0}
                step={1}
            />
        </div>
    );
}
